import { QUALITY_REVIEW_SERVICE_CODE, QUALITY_REVIEW_SKU } from '../constant';
import { useStudyGuard } from '../guard/study-guard';

export function useIsQualityReviewApplicable(): boolean {
  const {
    radiologistScan: { poetryMetadata, skuID },
  } = useStudyGuard();

  const hasQualityReviewService = (poetryMetadata?.servicesInfo ?? []).some((service) =>
    QUALITY_REVIEW_SERVICE_CODE.includes(service.code),
  );

  return QUALITY_REVIEW_SKU.includes(skuID) || hasQualityReviewService;
}
